import CheckCircle from "./SVG/check-circle.svg?react";

const CheckCircleIcon = () => {
  return <CheckCircle />;
};

export default CheckCircleIcon;
